import type { UserSourceResolver } from '../parsers/sourceResolvers';
import type { UserSourceHeaderName } from './sourceHeaders';
import type { AnalyticSourceParamInput } from './sourceParams';
import {
  getAffiliateTokenValue,
  getCampaignIdValue,

} from '../parsers/sourceResolvers';
import { REFERRAL_TOKEN_HEADER } from './sourceHeaders';
import { ANALYTIC_SOURCE_PARAM } from './sourceParams';

type UserSourceRule = {
  paramName: AnalyticSourceParamInput;
  resolver?: UserSourceResolver;
};

export const USER_SOURCE_RULES: Record<UserSourceHeaderName, UserSourceRule> = {
  [REFERRAL_TOKEN_HEADER]: { paramName: ANALYTIC_SOURCE_PARAM.ReferralToken },
  'x-affiliate-token': { paramName: ANALYTIC_SOURCE_PARAM.AffiliateToken, resolver: getAffiliateTokenValue },
  'x-utm-source': { paramName: ANALYTIC_SOURCE_PARAM.UtmSource },
  'x-utm-medium': { paramName: ANALYTIC_SOURCE_PARAM.UtmMedium },
  'x-campaign-id': { paramName: [ANALYTIC_SOURCE_PARAM.CampaignId, ANALYTIC_SOURCE_PARAM.UtmId], resolver: getCampaignIdValue },
  'x-utm-campaign': { paramName: ANALYTIC_SOURCE_PARAM.UtmCampaign },
  'x-utm-term': { paramName: ANALYTIC_SOURCE_PARAM.UtmTerm },
  'x-utm-content': { paramName: ANALYTIC_SOURCE_PARAM.UtmContent },
  'x-fbc': { paramName: ANALYTIC_SOURCE_PARAM.Fbclid },
  'x-gclid': { paramName: ANALYTIC_SOURCE_PARAM.Gclid },
  'x-ttclid': { paramName: ANALYTIC_SOURCE_PARAM.Ttclid },
  'x-msclkid': { paramName: ANALYTIC_SOURCE_PARAM.Msclkid },
  'x-tblci': { paramName: ANALYTIC_SOURCE_PARAM.Tblci },
  'x-click-id': {
    paramName: [
      ANALYTIC_SOURCE_PARAM.ClickId,
      ANALYTIC_SOURCE_PARAM.ClickIdAlt,
      ANALYTIC_SOURCE_PARAM.Aclid,
      ANALYTIC_SOURCE_PARAM.Cid,
    ],
  },
  'x-subid': { paramName: ANALYTIC_SOURCE_PARAM.Subid },
  'x-twclid': { paramName: ANALYTIC_SOURCE_PARAM.Twclid },
};
